// src/js/modules/atoz.js

const LETTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

export default function initAtoZ(root = document) {
  const modules = root.querySelectorAll("[data-module='atoz']");

  if (!modules.length) return;

  modules.forEach(buildAtoZ);
}

function buildAtoZ(module) {
  const source = module.querySelector(".sz-atoz-source");

  if (!source) return;

  const rawEntries = collectEntries(source);

  if (!rawEntries.length) return;

  const entries = dedupeEntries(rawEntries);

  entries.sort((a, b) =>
    a.sortTitle.localeCompare(b.sortTitle, undefined, {
      sensitivity: "base",
    }),
  );

  const grouped = groupEntries(entries);

  const content = renderGroups(grouped);

  source.hidden = true;

  module.insertBefore(content, source);

  const sidebarTarget = document.querySelector(
    ".sz-atoz-sidebar",
  );

  if (sidebarTarget) {
    sidebarTarget.appendChild(
      renderIndex(grouped),
    );
  }
}

function collectEntries(source) {
  return [...source.querySelectorAll(".sz-atoz-entry")]
    .map((entry) => {
      const link = entry.querySelector("a");

      if (!link) return null;

      const title =
        entry.dataset.title ||
        link.textContent.trim();

      const url = link.getAttribute("href") || "#";

      return {
        title,
        url,
        sortTitle: normaliseTitle(title),
        letter: getLetter(title),
      };
    })
    .filter(Boolean);
}

function dedupeEntries(entries) {
  const seen = new Set();

  return entries.filter((entry) => {
    const key =
      `${entry.title}|${entry.url}`.toLowerCase();

    if (seen.has(key)) return false;

    seen.add(key);

    return true;
  });
}

function normaliseTitle(title = "") {
  return title
    .trim()
    .replace(/^the\s+/i, "");
}

function getLetter(title = "") {
  const cleaned = normaliseTitle(title);

  const first = cleaned
    .charAt(0)
    .toUpperCase();

  return /^[A-Z]$/.test(first)
    ? first
    : "#";
}

function groupEntries(entries) {
  const groups = {};

  LETTERS.forEach((letter) => {
    groups[letter] = [];
  });

  groups["#"] = [];

  entries.forEach((entry) => {
    groups[entry.letter].push(entry);
  });

  return groups;
}

function renderGroups(grouped) {
  const wrapper = document.createElement("div");
  wrapper.className = "sz-atoz-groups";

  Object.entries(grouped).forEach(([letter, entries]) => {
    if (!entries.length) return;

    const section = document.createElement("section");
    section.className = "sz-atoz-section";
    section.setAttribute(
      "aria-labelledby",
      `listing${letter}`,
    );

    const heading = document.createElement("h2");
    heading.className = "sz-atoz-section__title";
    heading.id = `listing${letter}`;
    heading.textContent = letter;

    const list = document.createElement("ul");
    list.className = "sz-atoz-list";

    entries.forEach((entry) => {
      const item = document.createElement("li");

      const link = document.createElement("a");

      link.href = entry.url;
      link.textContent = entry.title;

      item.appendChild(link);
      list.appendChild(item);
    });

    section.appendChild(heading);
    section.appendChild(list);

    wrapper.appendChild(section);
  });

  return wrapper;
}

function renderIndex(grouped) {
  const nav = document.createElement("nav");
  nav.className = "sz-atoz-index-nav";

  const list = document.createElement("ul");
  list.className = "sz-atoz-index-list";

  const allLetters = ["#", ...LETTERS];

  allLetters.forEach((letter) => {
    const item = document.createElement("li");

    const hasEntries =
      grouped[letter] &&
      grouped[letter].length > 0;

    if (hasEntries) {
      const link = document.createElement("a");

      link.href = `#listing${letter}`;
      link.textContent = letter;

      item.appendChild(link);
    } else {
      const span = document.createElement("span");

      span.textContent = letter;
      span.setAttribute("aria-disabled", "true");

      item.appendChild(span);
    }

    list.appendChild(item);
  });

  nav.appendChild(list);

  return nav;
}